import { ComIbmCommerceCatalogCommandsSearchDisplayCmd } from './data-contracts';
import { HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class SearchDisplay<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * @description Get search layout view by search term.
	 *
	 * @tags search-display
	 * @name SearchdisplayBySearchTermDetail
	 * @summary Get search layout view by search term.
	 * @request GET:/store/{storeId}/searchdisplay/bySearchTerm
	 * @secure
	 * @response `200` `ComIbmCommerceCatalogCommandsSearchDisplayCmd` The requested completed successfully.
	 * @response `400` `void` Bad request. The request could not be understood by the server due to malformed syntax.
	 * @response `401` `void` Not authenticated. The user session is not valid.
	 * @response `403` `void` The user is not authorized to perform the specified request.
	 * @response `404` `void` The specified resource could not be found.
	 * @response `500` `void` Internal server error. For details, see the server log files.
	 */
	searchdisplayBySearchTermDetail = (
		storeId: string,
		query: {
			/** The search term. */
			searchTerm: string;
			/** The response format. Valid values are json and xml. If the request contains an input body, it must use the format specified in responseFormat. If the responseFormat is not specified, the accept  HTTP header determines the format of the response. If the accept  HTTP header is not specified then default response format is json. */
			responseFormat?: 'xml' | 'json';
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['searchdisplayBySearchTermDetail'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/searchdisplay/bySearchTerm`,
				params: _params,
				query: query,
				methodName: 'searchdisplayBySearchTermDetail',
			};
			logger.trace(traceData);
		}
		return this.http.request<ComIbmCommerceCatalogCommandsSearchDisplayCmd, void>({
			path: `/store/${storeId}/searchdisplay/bySearchTerm`,
			method: 'GET',
			query: query,
			secure: true,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
